import { useEffect, useState, useCallback, version, useRef } from "react";
import Loader from "../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import * as apicall from "../../components/Apicall";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import OtpInput from "react-otp-input";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import create_profile_icon from "../../assets/images/create_profile_icon.png";
import utilstopAppointmentLogo from "../../assets/images/EzietPro Logo.svg";
import { Col, Form, Row } from "react-bootstrap";
import { FaPhoneAlt } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";
import ReCAPTCHA from "react-google-recaptcha";
import * as constants from "../../constants/Constants";
import RotateDevicePopup from "../../components/RotateDevicePopup/RotateDevicePopup";

const Login = () => {
  const [step, setStep] = useState(1);
  const [fullNumber, setFullNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [loader, setLoader] = useState(false);
  const [isNumberValid, setIsNumberValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [showMailLogin, setShowMailLogin] = useState(false);
  const [errorMessageMail, setErrorMessageMail] = useState("");
  const [otp, setOtp] = useState("");
  const [count, setCount] = useState(120);
  const [otpRes, setOtpRes] = useState({});
  const [resendEnabled, setResendEnabled] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const navigate = useNavigate();
  const recaptchaRef = useRef(null);
  // Validate phone number input
  const numberOnChanges = async (value, country, formattedValue) => {
    setFullNumber(value);

    // Define minimum length requirements for each country
    const countryMinLengths = {
      in: 10, // India: 10 digits
      ae: 9, // UAE: 9 digits (excluding country code)
    };

    const minLength = countryMinLengths[country.countryCode] || 10;
    const phoneNumberWithoutCode = value.replace(country.dialCode, "").trim();

    if (phoneNumberWithoutCode.length >= minLength) {
      setIsNumberValid(true);
      setErrorMessage("");
      setCountryCode(country.dialCode);
      setPhoneNumber(phoneNumberWithoutCode);
    } else {
      setIsNumberValid(false);
      setErrorMessage(
        `Please enter a valid ${country.name} phone number (minimum ${minLength} digits)`
      );
    }
  };
  const handleCaptcha = (token) => {
    setCaptchaToken(token);
  };
  // Generate OTP
  const getOTP = async () => {
    setErrorMessage("");

    if (!isNumberValid) {
      setErrorMessage("Please enter a valid phone number.");
      return;
    }

    if (!captchaToken) {
      setCaptchaError("Please complete reCAPTCHA.");
      return;
    }

    try {
      setLoader(true);
      setCount(120);
      setResendEnabled(false);

      const data = {
        mobileNumber: fullNumber,
        is_mobile: true,
        "g-recaptcha-response": captchaToken,
      };

      const res = await apicall.post(data, "ezp_mobile_login");
      setOtpRes(res);
      setStep(2);
      recaptchaRef.current.reset();
      setCaptchaToken(null);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoader(false);
    }
  };

  const emailSend = async () => {
    if (errorMessageMail) {
      return;
    }
    if (!captchaToken) {
      setCaptchaError("Please complete reCAPTCHA.");
      return;
    }

    try {
      setLoader(true);

      const data = {
        email: email,
      };

      const res = await apicall.post(data, "ezp_email_login");
      setOtpRes(res);
      setStep(2);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoader(false);
    }
  };

  const passwordVerify = async () => {
    if (errorMessageMail) {
      return;
    }

    try {
      setLoader(true);

      const data = {
        user_id: otpRes.user_id,
        role: otpRes.role,
        email: email,
        password: password,
      };

      // console.log("data------", data);

      const resData = await apicall.ezp_password_verify(data);
      localStorage.setItem("login_type", "email");
      // console.log("res---resData---", resData);

      const role = await apicall.getRole();
      // console.log("role---", role);
      if (otpRes?.is_profileCreated) {
        let isStepUpDone = await setUpIsDone();
        if (!isStepUpDone) {
          // console.log("navigate to setup---");
          navigate("/setup");
        } else {
          navigate("/dashboard");
        }
      }
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoader(false);
    }
  };

  // console.log("otpRes----", otpRes);

  const setUpIsDone = async () => {
    try {
      let [
        ezpMyProfile,
        services_api,
        service_type_api,
        get_ezp_service_providers,
        get_ezp_booking,
      ] = await Promise.all([
        apicall.get(`ezpMyProfile`),
        apicall.get(`get_ezp_service`),
        apicall.get(`get_ezp_service_types`),
        apicall.get(`get_ezp_service_providers`),
        apicall.get(`get_ezp_booking?page=1&limit=1`),
      ]);
      let ans = {
        profile: ezpMyProfile?.data?.[0]?.state_name ? true : false,
        service: services_api?.data?.length > 0,
        type: service_type_api?.data?.length > 0,
        crew: get_ezp_service_providers?.data?.length > 0,
        order: get_ezp_booking?.data?.length > 0,
      };
      for (let i of Object.values(ans)) {
        if (!i) {
          return false;
        }
      }
      return true;
    } catch (e) {
      console.log("setUpis Done---", e);
    }
  };

  // Verify OTP
  const verifyOtp = async () => {
    if (otp.length !== 6) {
      setErrorMessage("Please enter 6-digit OTP.");
      return;
    }

    try {
      setLoader(true);

      const data = {
        mobileNumber: fullNumber,
        otp: otp,
        twilioService_id: otpRes.twilioService_id,
        user_id: otpRes.user_id,
        role: otpRes.role,
      };

      let ans = await apicall.verifyOTP(data);
      localStorage.setItem("login_type", "phone");
      // console.log("ans-------", ans);
      const role = apicall.getRole();
      // console.log("role---", role);
      if (otpRes?.is_profileCreated) {
        let isStepUpDone = await setUpIsDone();
        if (!isStepUpDone) {
          // console.log("navigate to setup---");
          navigate("/setup");
        } else {
          // console.log("navigate to dashboard...---");
          navigate(role === "3" ? "/dashboard" : "/vendors");
        }
      } else {
        navigate(`/profile-setup?phone_number=${fullNumber}`);
      }
    } catch (e) {
      console.log("e--------verigyOTP-----", e);
      toast.error(e.message.replace("Error - verifyOtp:", ""));
    } finally {
      setLoader(false);
    }
  };

  const verifyCODE = async () => {
    if (otp.length !== 6) {
      setErrorMessage("Please enter 6-digit OTP.");
      return;
    }

    if (!captchaToken) {
      setCaptchaError("Please complete reCAPTCHA.");
      return;
    }

    try {
      setLoader(true);

      const data = {
        mobileNumber: fullNumber,
        otp: otp,
        twilioService_id: otpRes.twilioService_id,
        user_id: otpRes.user_id,
        role: otpRes.role,
      };

      let ans = await apicall.verifyCODE(data);
      localStorage.setItem("login_type", "email");
      // console.log("ans-------", ans);
      const role = apicall.getRole();
      // console.log("role-verifycode--", role);

      if (otpRes?.is_profileCreated) {
        let isStepUpDone = await setUpIsDone();
        if (!isStepUpDone) {
          // console.log("navigate to setup---");
          navigate("/setup");
        } else {
          // console.log("navigate to dashboard...---");
          navigate(role === "3" ? "/dashboard" : "/vendors");
        }
      } else {
        navigate(`/profile-setup?email=${email}`);
      }
    } catch (e) {
      console.log("e--------verigyOTP-----", e);
      toast.error(e.message.replace("Error - verifyOtp:", ""));
    } finally {
      setLoader(false);
    }
  };

  // Check if user is already logged in
  const isUserLoggedIn = useCallback(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const role = apicall.getRole();
      // navigate(role === "5" ? "/dashboard" : "/vendors");
    }
  }, [navigate]);

  // Handle Enter key press
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !loader) {
      e.preventDefault();
      step === 1 ? getOTP() : showMailLogin ? verifyCODE() : verifyOtp();
    }
  };

  // Timer for OTP resend
  useEffect(() => {
    let timer;
    if (step === 2 && count > 0) {
      timer = setTimeout(() => setCount((c) => c - 1), 1000);
    } else if (count === 0) {
      setResendEnabled(true);
    }
    return () => clearTimeout(timer);
  }, [count, step]);

  // Check auth status on mount
  useEffect(() => {
    isUserLoggedIn();
  }, [isUserLoggedIn]);

  // Format timer display
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  // Custom OTP input renderer (without keydown handler)
  const renderOtpInput = (props) => <input {...props} />;

  const handleChange = (event) => {
    try {
      setEmail(event.target.value);
    } catch (e) {
      console.log("err----", e);
    }
  };

  // console.log("----otpRes---", otpRes, step);

  return (
    <>
      <RotateDevicePopup />
      <div>
        <header>
          <nav className="p-2 background-color-white">
            <img
              src={utilstopAppointmentLogo}
              alt={"vendor Name"}
              style={{ width: "150px", height: "50px" }}
            />
          </nav>
        </header>
        <Row className="profile_bg_color w-100" onKeyDown={handleKeyDown}>
          <Col md={8} className="flex_center">
            <div className="left_row">
              <h1 className="title_head">
                Join Us and Unlock Endless Possibilities!
              </h1>

              <h6 className="title_sub_head">
                Access your account and manage your bookings easily. Stay
                connected with your services, track appointments, and enjoy a
                seamless experience with Utilstop.
              </h6>
            </div>
          </Col>
          <Col md={4} className="background-color-red">
            <div onKeyDown={handleKeyDown}>
              <div className="d-flex pt-5" style={{ marginRight: "35px" }}>
                <div
                  className="shadow-lg bg-body rounded sm-w-100 tab-adjust"
                  style={{ width: "500px" }}
                >
                  <div className="p-5 pt-4">
                    <div className=" mb-3">
                      <img
                        src={create_profile_icon}
                        alt={"create_profile_icon"}
                        style={{ width: "30px", height: "auto" }}
                      />
                      <h1 className="title_bold">Login</h1>
                    </div>
                    <div className="d-flex mb-4 normal_tab">
                      <div
                        className={
                          "p-2 w-50 cursor-pointer normal_tab d-flex align-items-center justify-content-center gap-2" +
                          (!showMailLogin ? " mobile-primary" : "")
                        }
                        onClick={() => {
                          setStep(1);
                          setOtpRes({});
                          setPassword("");
                          setShowMailLogin(false);
                        }}
                      >
                        <FaPhoneAlt />
                        <span>Phone</span>
                      </div>

                      <div
                        className={
                          "p-2 w-50 cursor-pointer normal_tab d-flex align-items-center justify-content-center gap-2" +
                          (showMailLogin ? " mobile-primary" : "")
                        }
                        onClick={() => {
                          setStep(1);
                          setOtpRes({});
                          setPassword("");
                          setShowMailLogin(true);
                        }}
                      >
                        <MdOutlineEmail />
                        <span>Email</span>
                      </div>
                    </div>
                    {step === 1 ? (
                      <>
                        {!showMailLogin ? (
                          <div
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.stopPropagation();
                                getOTP();
                              }
                            }}
                          >
                            <div className="">
                              <label
                                htmlFor="phone"
                                className="label text-dark"
                              >
                                Enter Phone Number
                              </label>
                              <PhoneInput
                                onlyCountries={["in", "ae"]}
                                country={"in"}
                                value={fullNumber}
                                onChange={(value, country, formattedValue) =>
                                  numberOnChanges(
                                    value,
                                    country,
                                    formattedValue
                                  )
                                }
                                inputStyle={{ width: "100%" }}
                                enableSearch={false}
                              />

                              {errorMessage && (
                                <div className="label text-danger">
                                  {errorMessage}
                                </div>
                              )}
                            </div>
                            <div className="consent-text">
                              By continuing, you agree to{" "}
                              <span
                                className="link-text"
                                onClick={() =>
                                  window.open("https://ezeitpro.com/", "_blank")
                                }
                              >
                                EzeitPro Customer Agreement
                              </span>{" "}
                              or other agreement for UtilStop, and the{" "}
                              <span
                                className="link-text"
                                onClick={() =>
                                  window.open("https://ezeitpro.com/", "_blank")
                                }
                              >
                                Privacy Notice
                              </span>
                              . This site uses essential cookies. See our{" "}
                              <span
                                className="link-text"
                                onClick={() =>
                                  window.open("https://ezeitpro.com/", "_blank")
                                }
                              >
                                Cookie Notice
                              </span>{" "}
                              for more information.
                            </div>
                            <div className="d-flex flex-column justify-content-center mt-3 align-items-center">
                              <ReCAPTCHA
                                ref={recaptchaRef} // optional if you want to reset
                                sitekey={constants?.WEB_CAPTCHA_TOKEN}
                                onChange={(token) => {
                                  setCaptchaToken(token);
                                  setCaptchaError(""); // clear error when captcha is completed
                                }}
                              />
                              {captchaError && (
                                <div className="label text-danger mt-2">
                                  {captchaError}
                                </div>
                              )}
                            </div>

                            <div className="text-center pt-4">
                              <button
                                style={{ marginLeft: "40%" }}
                                className="btn btn-block primaryBackground text-white"
                                onClick={getOTP}
                                disabled={loader || !captchaToken}
                              >
                                {loader ? (
                                  <Loader style={{ width: 40, height: 20 }} />
                                ) : (
                                  "Get OTP"
                                )}
                              </button>
                            </div>
                          </div>
                        ) : (
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              emailSend();
                            }}
                          >
                            <div
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.stopPropagation();
                                  emailSend();
                                }
                              }}
                            >
                              <div className="">
                                <label
                                  htmlFor="phone"
                                  className="label text-dark"
                                >
                                  Enter Email ID
                                </label>

                                <Form.Group>
                                  <Form.Control
                                    type="email"
                                    name="email"
                                    placeholder="Enter email address"
                                    onChange={(e) => {
                                      handleChange(e);
                                      const value = e.target.value;

                                      if (
                                        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                                          value
                                        )
                                      ) {
                                        setErrorMessageMail(
                                          "Invalid email format"
                                        );
                                      } else {
                                        setErrorMessageMail("");
                                      }
                                    }}
                                    className="form-input"
                                    required
                                  />

                                  {errorMessageMail && (
                                    <div className="label text-danger">
                                      {errorMessageMail}
                                    </div>
                                  )}
                                </Form.Group>
                              </div>
                              <div className="consent-text">
                                By continuing, you agree to{" "}
                                <span
                                  className="link-text"
                                  onClick={() =>
                                    window.open(
                                      "https://ezeitpro.com/",
                                      "_blank"
                                    )
                                  }
                                >
                                  EzeitPro Customer Agreement
                                </span>{" "}
                                or other agreement for UtilStop, and the{" "}
                                <span
                                  className="link-text"
                                  onClick={() =>
                                    window.open(
                                      "https://ezeitpro.com/",
                                      "_blank"
                                    )
                                  }
                                >
                                  Privacy Notice
                                </span>
                                . This site uses essential cookies. See our{" "}
                                <span
                                  className="link-text"
                                  onClick={() =>
                                    window.open(
                                      "https://ezeitpro.com/",
                                      "_blank"
                                    )
                                  }
                                >
                                  Cookie Notice
                                </span>{" "}
                                for more information.
                              </div>
                              <div className="d-flex flex-column justify-content-center mt-3 align-items-center">
                                <ReCAPTCHA
                                  ref={recaptchaRef} // optional if you want to reset
                                  sitekey={constants?.WEB_CAPTCHA_TOKEN}
                                  onChange={(token) => {
                                    setCaptchaToken(token);
                                    setErrorMessage(""); // clear error when captcha is completed
                                  }}
                                />
                                {errorMessage && (
                                  <div className="label text-danger mt-2">
                                    {errorMessage}
                                  </div>
                                )}
                              </div>
                              <div className="text-center pt-4">
                                <button
                                  style={{ marginLeft: "40%" }}
                                  className="btn btn-block primaryBackground text-white"
                                  // onClick={emailSend}
                                  disabled={loader || !captchaToken}
                                >
                                  {loader ? (
                                    <Loader style={{ width: 40, height: 20 }} />
                                  ) : (
                                    "Submit"
                                  )}
                                </button>
                              </div>
                            </div>
                          </form>
                        )}
                      </>
                    ) : (
                      <>
                        {otpRes?.is_profileCreated && showMailLogin ? (
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              passwordVerify();
                            }}
                          >
                            <div
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.stopPropagation();
                                  passwordVerify();
                                }
                              }}
                            >
                              {/* <div className="">
                        <label htmlFor="phone" className="label text-dark">
                          Password
                        </label>

                        <Form.Group>
                          <Form.Control
                            type="text"
                            name="email"
                            value={password}
                            placeholder="Enter password"
                            onChange={(e) => {
                              const value = e.target.value;
                              setPassword(value);
                            }}
                            className="form-input"
                          />
                        </Form.Group>
                      </div> */}
                              <div>
                                <label
                                  htmlFor="password"
                                  className="label text-dark"
                                >
                                  Password
                                </label>

                                <Form.Group style={{ position: "relative" }}>
                                  <Form.Control
                                    type="text"
                                    value={
                                      showPassword
                                        ? password
                                        : "*".repeat(password.length)
                                    }
                                    placeholder="Enter password"
                                    required
                                    onChange={(e) => {
                                      const inputValue = e.target.value;

                                      if (!showPassword) {
                                        if (
                                          inputValue.length > password.length
                                        ) {
                                          const newChar =
                                            inputValue[inputValue.length - 1];
                                          setPassword(password + newChar);
                                        } else {
                                          setPassword(
                                            password.slice(0, inputValue.length)
                                          );
                                        }
                                      } else {
                                        setPassword(inputValue);
                                      }
                                    }}
                                    className="form-input"
                                    style={{ paddingRight: "40px" }}
                                  />

                                  <span
                                    onClick={() =>
                                      setShowPassword(!showPassword)
                                    }
                                    style={{
                                      position: "absolute",
                                      right: "12px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      cursor: "pointer",
                                      color: "#6c757d",
                                    }}
                                  >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                  </span>
                                </Form.Group>
                              </div>

                              <div className="text-center pt-4">
                                <button
                                  style={{ marginLeft: "40%" }}
                                  className="btn btn-block primaryBackground text-white"
                                  // onClick={passwordVerify}
                                  disabled={loader}
                                >
                                  {loader ? (
                                    <Loader style={{ width: 40, height: 20 }} />
                                  ) : (
                                    "Submit"
                                  )}
                                </button>
                              </div>
                            </div>
                          </form>
                        ) : (
                          <div
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.stopPropagation();
                                showMailLogin ? verifyCODE() : verifyOtp();
                              }
                            }}
                          >
                            <div className="greyColor">
                              Enter the code we just sent on your{" "}
                              {showMailLogin ? "mail" : "phone"}
                            </div>
                            {!showMailLogin ? (
                              <div className="primaryColorText">
                                +{countryCode} {phoneNumber}
                              </div>
                            ) : (
                              <div className="primaryColorText">{email}</div>
                            )}

                            <div className="d-flex justify-content-center  otp-wrapper">
                              <OtpInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={6}
                                renderSeparator={<span>&nbsp;&nbsp;</span>}
                                renderInput={renderOtpInput}
                                containerStyle={{
                                  width: "70%",
                                  height: "100px",
                                  alignItems: "center",
                                }}
                                inputStyle={{ width: "40%", height: "50%" }}
                              />
                            </div>

                            {errorMessage && (
                              <div className="label text-danger text-center">
                                {errorMessage}
                              </div>
                            )}

                            <div className="text-center">
                              <button
                                style={{ marginLeft: "40%" }}
                                className="btn btn-block primaryBackground text-white"
                                onClick={showMailLogin ? verifyCODE : verifyOtp}
                                disabled={loader || otp.length !== 6}
                              >
                                {loader ? (
                                  <Loader style={{ width: 40, height: 20 }} />
                                ) : !showMailLogin ? (
                                  "Login"
                                ) : (
                                  "Submit"
                                )}
                              </button>
                            </div>

                            {resendEnabled ? (
                              <div
                                className="text-center pt-2 primaryColorText"
                                onClick={showMailLogin ? verifyCODE : getOTP}
                                style={{ cursor: "pointer" }}
                              >
                                <u>Resend {showMailLogin ? "Code" : "OTP"}</u>
                              </div>
                            ) : (
                              <div className="greyColor text-center pt-2">
                                Resend OTP in{" "}
                                <span className="primaryColorText">
                                  {formatTime(count)}
                                </span>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Login;
